<template>
	<div class="glorylist">
		<div class="list_a">
			<span :class="regionindex==0?'region_cur':'region'" @click="changeregion(0)">全国</span>
			<span :class="regionindex==1?'region_cur':'region'" @click="changeregion(1)">全省</span>
		</div>
		
		<div class="list_b">
			<div :class="tipindex == index?'signlecon_cur':'signlecon'" 
			@click="changetab(index)"
			v-for="(item,index) in tiplist" :key="index">
				{{item}}
			</div>
		</div>
		
		<div class="list_c">
			<el-carousel loop indicator-position="none" arrow="never"
			 height="315px" ref="img" >
				<el-carousel-item v-for="(items,i) in glorylist" :key="i">				
					<div class="glorycon">
						<div class="signle" v-for="(item,y) in items" :key="y" @click="seedetail(item)">
							<el-image fit='cover' :src="$imgUrl + item.thumbnail_dictText" alt=""></el-image>
							<div class="team">{{item.title || ''}}</div>
							<div class="title overfh" :title="item.honoraryTitle">
								{{item.honoraryTitle || ''}}
							</div>
						</div>					
					</div>				
				</el-carousel-item>
			</el-carousel>
			
		</div>
		
	</div>
	
</template>

<script>


export default {
 
  data: function() {
		return {
			glorylist:[],
			tiplist:["优秀少先队员","优秀少先队辅导员","优秀少先队集体","红领巾奖章五星章"],
			tipindex:0,
			regionindex:0,
			infoType:"4",
		  
		};
		
  },
  
  mounted() {
  	  this.getGlory()
  },
  
  methods: {
	    //光荣榜
	    getGlory(){
			var that = this
			var flag = 1
			if(this.tipindex == 0){
				flag = 1;
			}else if(this.tipindex == 1){
				flag = 2;
			}else if(this.tipindex == 2){
				flag = 3;
			}else if(this.tipindex == 3){
				flag = this.regionindex==0?5:4
				// flag = 4;
			}
			this.$get(`web/info/gloryList?flag=${flag}&pageSize=18&pageNo=1&infoType=${this.infoType}`).then(res=>{
				  if(res.success){
					    that.glorylist = [];
						// this.glorylist = res.result.records
						var list = [];
						var ifwhole = false
						if(res.result.records.length%6 == 0){
							ifwhole = true
						}
						var len = res.result.records.length;
						res.result.records.forEach(function(val,key,arr){
						    // console.log(val,key,arr);	
							list.push(val);
							if((key+1)%6 == 0){
								that.glorylist.push(list);
								list = [];
							}
							if(!ifwhole){
								if(key+1 == len){
									that.glorylist.push(list);
								}
							}	
						})
						
						// console.log(this.glorylist)
				  }
			})
	    },
	  
		seedetail(item){
			this.$router.push({ path: '/gloriousedit?id='+item.id+"&type="+this.tipindex+"&region="+this.regionindex });
		},
	  
		changetab(index){
			this.tipindex = index
			this.getGlory()
		},
		
		changeregion(index){
			this.regionindex = index
			
			if(index == 0){
				this.infoType = "4"
				this.tiplist[3]='红领巾奖章五星章';
			}else if(index == 1){
				this.infoType = "5"
				this.tiplist[3]='红领巾奖章四星章'
			}
			this.getGlory()
		},
			
			
  },
  
  
};
</script>

<style scoped=" scoped" lang="scss">
	
.glorylist{
	margin-top: 20px;
	.list_a{
		.region_cur{
			cursor: pointer;
			font-size: 18px;
			font-weight: 400;
			color: #E81414;
			margin-right: 40px;
		}
		.region{
			cursor: pointer;
			font-size: 18px;
			font-weight: 400;
			color: #333333;
			margin-right: 40px;
		}
		
	}
	
	.list_b{
		height: 100px;
		display: flex;
		align-items:center;
		justify-content: center;
		.signlecon_cur,.signlecon,.signlecon:hover{ 
			cursor: pointer;
			min-width: 210px;
			height: 50px;
			line-height: 50px;
			text-align: center;
			border-radius: 20px;
			font-size: 20px;
			font-weight: 400;
			margin-right: 30px;
		}
		.signlecon_cur{
			background: #E81414;
			color: #FFFFFF;
		}
		.signlecon{
			border: 1px solid #D80C18;
			color: #333333;
		}
		.signlecon:hover{
			background: #E81414;
			color: #FFFFFF;
		}
	}
	
	.list_c{
		.glorycon{
			display: flex;
			align-items: flex-start;
			margin-top: 50px;
			.signle{
				// cursor: pointer;
				width: 220px;
				display: flex;
				flex-direction: column;
				align-items: center;
				.el-image{
					border: 1px solid #ededed;
					width: 119px;
					height: 169px;
					cursor: pointer;
				}
				.team{
					height: 40px;
					line-height: 40px;
					text-align: center;
					font-size: 16px;
					font-weight: 400;
					color: #333333;
					cursor: pointer;
				}
				.title{
					padding: 0px 20px;
					text-align: center;
					font-size: 16px;
					font-weight: 400;
					color: #999999;
					cursor: pointer;
				}
			}
		}
		
	}
	
	
	
}

</style>
